import { createWebHistory, createRouter } from "vue-router";
import LoginForm from "./components/LoginForm.vue";
import SignupForm from "./components/SignupForm.vue";
import PasswordReset from "./components/PasswordReset.vue";
import ResendActivation from "./components/ResendActivation.vue";
import PhoneEnter from "./components/PhoneEnter.vue";
import PhoneCode from "./components/PhoneCode.vue";
//import Agreement from "./components/Agreement.vue"; AGREEMENT DISABLED
import MainDashboard from "./components/MainDashboard.vue";
import SubscriptionPage from "./components/SubscriptionPage.vue";
import DownloadsPage from "./components/DownloadsPage.vue";
import UserProfile from "./components/UserProfile.vue";
import { useAuthStore } from "./store/auth";
import { useUserStore } from "./store/user";

const publicPages = new Set(["/login", "/signup", "/password-reset", "/resend-activation"]);
const stateRestrictedPages = new Set(["/phone-enter", "/phone-code"]); //AGREEMENT DISABLED
const privatePages = new Set([...stateRestrictedPages, "/dashboard", "/dashboard/subscription", "/dashboard/downloads", "/dashboard/profile"]);
const allPages = new Set([...privatePages, ...publicPages]);

const routes = [
    {
        path: "/",
        component: LoginForm
    },
    {
        path: "/login",
        component: LoginForm
    },
    {
        path: "/signup",
        component: SignupForm
    },
    {
        path: "/password-reset",
        component: PasswordReset
    },
    {
        path: "/resend-activation",
        component: ResendActivation
    },
    {
        path: "/phone-enter",
        component: PhoneEnter
    },
    {
        path: "/phone-code",
        component: PhoneCode
    },
    // {  AGREEMENT DISABLED
    //     path: "/agreement",
    //     component: Agreement
    // },
    {
        path: "/dashboard",
        component: MainDashboard,
        children: [
            { path: "", component: SubscriptionPage },
            { path: "subscription", component: SubscriptionPage },
            { path: "downloads", component: DownloadsPage },
            { path: "profile", component: UserProfile }
        ]
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {

    const validPage = allPages.has(to.path);
    const authRequired = privatePages.has(to.path);
    let loggedIn = false;
    const user = useUserStore();
    const auth = useAuthStore();
    if (auth?.accessToken) {
        loggedIn = true;
    }

    //TODO REMOVE CONSOLE OUTPUT
    console.log("before each", to.path);
    if (validPage) {
        console.log("valid page");
        if (authRequired) {
            console.log("auth required page");
            if (loggedIn) {
                console.log("logged in");

                const activationState = user?.profile?.activationState;
                console.log("activationState", activationState);
                if (activationState === "activated") {
                    if (stateRestrictedPages.has(to.path)) {
                        console.log("prevent state restricted page");
                        next("/dashboard");
                    } else {
                        console.log("just next");
                        next();
                    }
                } else {
                    if (to.path === "/" + activationState) {
                        console.log("just next");
                        next();
                    } else {
                        console.log("readirect to state ", activationState);
                        next("/" + activationState);
                    }
                }
            } else {
                next("/login");
            }
        } else {
            console.log("no auth required page");
            if (loggedIn) {
                console.log("redirect dashboard");
                next("/dashboard");
            } else {
                console.log("just next");
                next();
            }
        }
    } else {
        console.log("invalid page");
        if (loggedIn) {
            console.log("redirect dashboard");
            next("/dashboard");
        } else {
            console.log("redirect login");
            next("/login");
        }
    }
});

export { router };